import React from 'react';
import '../css/footer.css';

function Footer(props){

    
    return(  
        <>  
            <p id="footer" className={props.isVisibleMobile?'pt-5 mb-0 pb-4 fw-normal text-center fixed-bottom  ':
                'pt-5 mb-0 pb-4 fw-normal text-center fixed-bottom  ocultarMobile'}> 
                
                    <a className="linkNewAge" href='https://new-age.com.ar/'>Created by <span className='fw-bolder'>NewAge</span></a>
                
               
            </p>    
        </>
    );
}


export default Footer;